var map = {
	"./cy.json": [
		89423,
		423
	],
	"./en-gb.json": [
		25978,
		978
	],
	"./en-us.json": [
		52719,
		719
	],
	"./vi-vn.json": [
		82749,
		749
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 21050;
module.exports = webpackAsyncContext;